<template>
  <a-card :bordered="false" :loading="loading">
    <a-descriptions v-if="data">
      <a-descriptions-item label="考试场次" :span="3">{{ data.session_id }}</a-descriptions-item>
      <a-descriptions-item label="考试链接" :span="3">{{ data.session_url }}</a-descriptions-item>
      <a-descriptions-item label="准考证号">{{ data.exam_no }}</a-descriptions-item>
      <a-descriptions-item label="身份证号">{{ data.exam_idcard }}</a-descriptions-item>
      <a-descriptions-item label="手机号">{{ data.exam_mobile }}</a-descriptions-item>
      <a-descriptions-item label="姓名">{{ data.exam_realname }}</a-descriptions-item>
      <a-descriptions-item label="性别">{{ data.exam_sex }}</a-descriptions-item>
      <a-descriptions-item label="邮箱">{{ data.exam_email }}</a-descriptions-item>
      <a-descriptions-item label="学历">{{ data.exam_education }}</a-descriptions-item>
      <a-descriptions-item label="身份">{{ data.exam_role }}</a-descriptions-item>
      <a-descriptions-item label="在读学校/在职公司">{{ data.exam_position }}</a-descriptions-item>
      <a-descriptions-item label="考试方向">{{ data.exam_direction }}</a-descriptions-item>
      <a-descriptions-item label="考试时间">{{ data.exam_time }}</a-descriptions-item>
      <a-descriptions-item label="考试状态">{{
        data.exam_state === 0 ? '未结束' : '已结束'
      }}</a-descriptions-item>
      <a-descriptions-item label="是否通过">{{ data.exam_passed === 0 ? '是' : '否' }}</a-descriptions-item>
      <a-descriptions-item label="考试分数">{{ data.exam_score }}</a-descriptions-item>
      <a-descriptions-item label="证书获得时间">{{
        data.exam_crt_gettime === 0 ? '未获得' : data.exam_crt_gettime
      }}</a-descriptions-item>
      <a-descriptions-item label="证书编号" v-if="data.exam_crt_gettime !== 0">{{
        data.exam_crt_no
      }}</a-descriptions-item>
      <a-descriptions-item label="证书有效期截止时间" v-if="data.exam_crt_gettime !== 0">{{
        data.exam_crt_limittime
      }}</a-descriptions-item>
      <a-descriptions-item label="证书路径" v-if="data.exam_crt_gettime !== 0">{{
        data.exam_crtpath
      }}</a-descriptions-item>
    </a-descriptions>
    <!-- <a-divider style="margin-bottom: 32px" v-if="data.certificates && data.courses"/>
      <a-comment v-if="data.courses">
        <a slot="author">{{ data.courses.title }}</a>
        <a-avatar
          slot="avatar"
          :src="globalUrl + data.courses.thumb"
          :alt="data.courses.title"
        />
        <p slot="content">{{ data.courses.description }}</p>
      </a-comment>
      <a-comment v-if="data.certificates">
        <a slot="author">{{ data.certificates.title }}</a>
        <a-avatar
          slot="avatar"
          :src="globalUrl + data.certificates.thumb"
          :alt="data.certificates.title"
        />
        <p slot="content">{{ data.certificates.description }}</p>
      </a-comment> -->
    <!-- <a-divider style="margin-bottom: 32px" v-if="data.user"/>
      <a-descriptions title="用户信息" v-if="data.user">
        <a-descriptions-item label="用户姓名">{{ data.user.name }}</a-descriptions-item>
        <a-descriptions-item label="联系电话">{{ data.user.phone }}</a-descriptions-item>
        <a-descriptions-item label="取货地址">{{ data.user.address }}</a-descriptions-item>
        <a-descriptions-item label="备注">	无</a-descriptions-item>
      </a-descriptions> -->
  </a-card>
</template>

<script>
import { requestGet } from '@/api/api'

export default {
    name: 'ModelDetail',
    props: {
        id: {
            type: [String, Number],
            default: 1
        }
    },
    data () {
        return {
            loading: false,
            data: []
        }
    },
    mounted () {
        this.getDetail()
    },
    methods: {
        getDetail () {
            this.loading = true
            const id = this.id
            requestGet('/finances/baidu/' + id)
                .then(res => {
                    const { result } = res
                    this.loading = false
                    this.data = result
                })
                .catch(err => {
                    this.$notification.error(err.message)
                })
        },
        /**
         * 提交按钮
         * form表单提交
         * @form
         */
        onOk () {
            return new Promise(resolve => {
                resolve(true)
            })
        },
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>
